import * as React from 'react';
import clsx from 'clsx';

interface ShareHeaderProps {
  title: string;
}

export const ShareHeader: React.FC<ShareHeaderProps> = ({ title }) => (
  <h3
    className={clsx(
      'font-sans font-bold tracking-normal text-brand-800',
      // Mobile: 24px size, 25px line-height
      'text-24 leading-25',
      // Desktop: 32px size, 27px line-height
      'md:text-32 md:leading-27'
    )}
  >
    {title}
  </h3>
);
